export default "__VITE_ASSET__DQVvRtNK__"